<template>
  <div class="card section">
    <div class="subtitle is-4 has-text-link p-10 mb-0 mb-0">
      Paramétrage édition
    </div>
    <div class="card-content">
      <div class="content">
        <div class="column columns is-12 is-paddingless">
          <div class="column columns is-multiline is-5 is-marginless">
            <p class="subtitle is-6 mb-0">
              Faces LC
            </p>
            <div class="column is-12 is-paddingless">
              <div class="level">
                <div class="level-left">
                  <div class="level-item">
                    <p>Informations tarifaires</p>
                  </div>
                </div>
                <div class="level-right">
                  <div class="level-item">
                    <div class="field">
                      <b-switch v-model="infoTarifLc">
                        Afficher
                      </b-switch>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-12 is-paddingless">
              <div class="level">
                <div class="level-left">
                  <div class="level-item">
                    <p>Dates</p>
                  </div>
                </div>
                <div class="level-right">
                  <div class="level-item">
                    <div class="field">
                      <b-switch v-model="dateLc">
                        Afficher
                      </b-switch>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column"></div>
          <div class="column columns is-multiline is-6 is-marginless">
            <p class="subtitle is-6 mb-0">
              Réseaux temporaires / Réseaux LC
            </p>
            <div class="column is-12 p-5px">
              <div class="level">
                <div class="level-left">
                  <div class="level-item">
                    <p>Informations tarifaires</p>
                  </div>
                </div>
                <div class="level-right">
                  <div class="level-item">
                    <div class="field">
                      <b-switch v-model="infoTarifReseau">
                        Afficher
                      </b-switch>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-12 p-5px">
              <div class="level">
                <div class="level-left">
                  <div class="level-item">
                    <p>Dates</p>
                  </div>
                </div>
                <div class="level-right">
                  <div class="level-item">
                    <div class="field">
                      <b-switch v-model="dateReseau">
                        Afficher
                      </b-switch>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-12 p-5px">
              <div class="level">
                <div class="level-left">
                  <div class="level-item">
                    <p>Liste des faces</p>
                  </div>
                </div>
                <div class="level-right">
                  <div class="level-item">
                    <div class="field">
                      <b-switch v-model="listesFaesReseau">
                        Afficher
                      </b-switch>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-12 p-5px">
              <div class="level">
                <div class="level-left">
                  <div class="level-item">
                    <p>Cartographie</p>
                  </div>
                </div>
                <div class="level-right">
                  <div class="level-item">
                    <div class="field">
                      <b-switch v-model="cartoReseau">
                        Afficher
                      </b-switch>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <b-button @click="$emit('close')">
              Annuler
            </b-button>
          </div>
          <div class="level-item">
            <b-button type="is-primary"
            @click="enregistrerParametres()">
              Enregistrer
            </b-button>
          </div>
        </div>
        <div class="level-right"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const Panier = createNamespacedHelpers('panier');
export default {
  data() {
    return {
      infoTarifLc: true,
      dateLc: true,
      infoTarifReseau: true,
      dateReseau: true,
      listesFaesReseau: true,
      cartoReseau: true,
    };
  },
  methods: {
    ...Panier.mapActions({
      actionsparametreEdition: 'parametreEdition',
    }),
    enregistrerParametres() {
      this.actionsparametreEdition({
        infoTarifLc: this.infoTarifLc,
        dateLc: this.dateLc,
        infoTarifReseau: this.infoTarifReseau,
        dateReseau: this.dateReseau,
        listesFaesReseau: this.listesFaesReseau,
        cartoReseau: this.cartoReseau,
      });
      this.$emit('close');
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/previsualiserOpportunite/modalParametre.vue